import _403 from 'src/app/403/components/403';

export default [
  {
    path: '/403',
    name: '403',
    component: _403,
  },
];
